module.exports = __webpack_public_path__ + "media/images/bullet-arrow-5b68ba4d90faaa50ecf882e2add22856.png";